import { JsonSchemaValidator } from "@common/json-schema-validator";
import { IAMAccountIdentity } from "../interface";
import { iamAccountIdentity } from "../schema";

export class IAMAccountCreateCmd {
  private static validation = JsonSchemaValidator.compile(
    IAMAccountCreateCmd.validationSchema()
  );

  constructor(readonly value: IAMAccountCreateCmdRaw) {
    JsonSchemaValidator.assert(IAMAccountCreateCmd.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["identity"],
      properties: {
        identity: iamAccountIdentity
      },
      additionalProperties: false
    };
  }
}

interface IAMAccountCreateCmdRaw {
  identity: IAMAccountIdentity;
}
